import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import client, { apiCall } from '../../api/client';
import DataTable from '../../components/DataTable';
import StatusBadge from '../../components/StatusBadge';
import CopyButton from '../../components/CopyButton';
import Loader from '../../components/Loader';

export default function ApiKeys() {
  const [keys, setKeys] = useState([]);
  const [hasActivePlan, setHasActivePlan] = useState(true);
  const [label, setLabel] = useState('');
  const [error, setError] = useState('');
  const [creating, setCreating] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = () => {
    apiCall(client.get('/api_key/get_list')).then(setKeys).catch((e) => setError(e.message));
    apiCall(client.get('/credit_plan/active'))
      .then(() => setHasActivePlan(true))
      .catch(() => setHasActivePlan(false))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    setError('');
    setCreating(true);
    try {
      await apiCall(client.post('/api_key/create', { label: label || 'Default Key' }));
      setLabel('');
      load();
    } catch (err) {
      setError(err.message);
    } finally {
      setCreating(false);
    }
  };

  const handleRevoke = async (uniqueId) => {
    if (!window.confirm('Revoke this API key? Any application using it will stop working immediately.')) return;
    try {
      await apiCall(client.patch('/api_key/revoke', { uniqueId }));
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  const columns = [
    { key: 'label', label: 'Label' },
    {
      key: 'uniqueId', label: 'Key', render: (row) => (
        <div className="key-row">
          <span>{row.uniqueId}</span>
          <CopyButton text={row.uniqueId} />
        </div>
      )
    },
    { key: 'status', label: 'Status', render: (row) => <StatusBadge value={row.status} /> },
    {
      key: 'actions', label: '', render: (row) => (
        row.status === 'ACTIVE' && (
          <button className="btn btn-danger-outline btn-sm" onClick={() => handleRevoke(row.uniqueId)}>Revoke</button>
        )
      )
    },
  ];

  return (
    <div>
      <h1>API Keys</h1>
      {error && <div className="form-error">{error}</div>}

      {loading ? (
        <div className="card"><Loader label="Loading your API keys..." /></div>
      ) : hasActivePlan ? (
        <div className="card" style={{ marginBottom: 24 }}>
          <div className="card-header"><h3>Create a new key</h3></div>
          <form onSubmit={handleCreate} className="form-row" style={{ alignItems: 'flex-end' }}>
            <div className="form-group" style={{ flex: 3 }}>
              <label>Label</label>
              <input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="e.g. Production backend" />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <button type="submit" className="btn btn-primary btn-block" disabled={creating}>
                {creating ? 'Creating...' : 'Create key'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="card" style={{ marginBottom: 24 }}>
          <p>You need an active plan before you can create an API key.</p>
          <Link to="/pricing" className="btn btn-primary">Choose a plan</Link>
        </div>
      )}

      {!loading && (
        <div className="card">
          <DataTable columns={columns} rows={keys} emptyMessage="You haven't created any API keys yet." />
        </div>
      )}
    </div>
  );
}
